// export const companyDynamic1 = state => state.newsOnline.companyDynamic
// export const companyDynamicImg1 = state => state.newsOnline.companyDynamicImg
// export const dynamicTotal1 = state => state.newsOnline.dynamicTotal
// export const mediaReport1 = state => state.newsOnline.mediaReport
// export const mediaReportImg1 = state => state.newsOnline.mediaReportImg
// export const reportTotal1 = state => state.newsOnline.reportTotal
export const newsOnline = state => state.newsOnline



// WEBPACK FOOTER //
// ./src/vuex/getters.js